/**
 * This feature's routes, as constants.
 *
 * Separate from `routes.tsx` so a screen can link to another without
 * importing the module that builds the table — which imports the screens.
 */

export const CLIENTS_PATHS = {
  clients: "/clients",
  client: "/clients/$id",
  salesReps: "/commerciaux",
  portfolio: "/mon-portefeuille",
} as const;
